import tw from "tailwind-styled-components";

export const SvgIcon = tw.img`
    h-4 w-4 text-[16px]
`
export const OptionSvg = tw.img`
    h5- w-5 text-[16px]
`